import { render, staticRenderFns } from "./CompositeItemDetail.vue?vue&type=template&id=964f4e4e&scoped=true"
import script from "./CompositeItemDetail.vue?vue&type=script&lang=js"
export * from "./CompositeItemDetail.vue?vue&type=script&lang=js"
import style0 from "./CompositeItemDetail.vue?vue&type=style&index=0&id=964f4e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964f4e4e",
  null
  
)

export default component.exports